import React, { useState } from 'react'
import CustomCard from '../../Shared/Components/CustomCard/CustomCard'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import ActionButtons from '../../Shared/Components/ActionButtons'
import InfoIcon from '@mui/icons-material/Info';
import { useDeleteDiscountMutation, useGetDiscountsQuery } from '../Service/discountsApi'
import { useNavigate } from 'react-router-dom'
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';
import { DiscountsRoutes } from '../../../Router/path';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import DataTable, { ColumnConfig } from '../../Shared/Components/DataTable'
import { Discount } from '../Types/discountTypes'

const Discounts = () => {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedDiscountIds, setSelectedDiscountIds] = useState<number[]>([]);

    const { data, isLoading, isError, error } = useGetDiscountsQuery()

    const [deleteDiscount] = useDeleteDiscountMutation();
    const navigate = useNavigate();
    const handleCreate = useCreateRedirect(DiscountsRoutes.create);
    const handleDeleteSelected = useDeleteSelectedItems<number>(
        selectedDiscountIds,
        (id) => deleteDiscount(id).unwrap(),
        () => setSelectedDiscountIds([])
    );

    const columns: ColumnConfig<Discount>[] = [
        { key: "id", label: "ID" },
        { key: "name", label: "Nazwa" },
        { key: "startDate", label: "Data rozpoczęcia" },
        { key: "endDate", label: "Data zakończenia" },
        { key: "discountPercentage", label: "Procent zniżki" },
        { key: "discountAmount", label: "Kwota zniżki" },
        {
            key: "usePercentage",
            label: "Procentowa zniżka",
            render: (row) => (
                <input type="checkbox" disabled checked={row.usePercentage} />
            ),
        },



    ];
    return (
        <>
            <CustomCard
                icon={<InfoIcon fontSize="large" color="primary" />}
                title="Rabaty"
                subheader="Zarządzaj rabatami w systemie"
                sx={{ mb: 4 }}
            >
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" gutterBottom>
                        Na tej stronie zarządzasz wszystkimi dostępnymi zniżkami w systemie.
                        Możesz przeglądać listę istniejących rabatów wraz z podstawowymi informacjami (nazwa, wartość, typ procentowy/kwotowy, data ważności, status publikacji).
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Skorzystaj z przycisków, aby dodać nową rabat lub usunąć
                        wybrane pozycje.
                    </Typography>
                </Box>

                <ActionButtons
                    onCreate={handleCreate}
                    onDeleteSelected={handleDeleteSelected}
                />
            </CustomCard>
            <CustomCard >
                <DataTable
                    columns={columns}
                    data={data || []}
                    isLoading={isLoading}
                    isError={isError}
                    errorMessage={(error as any)?.data?.message}
                    getRowId={(row) => row.id}
                    onEdit={(id) => {
                        const item = data?.find(item => item.id === id);
                        if (item) {
                            navigate(DiscountsRoutes.update.replace(":discountId", item.id.toString()));
                        }
                    }}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={(newPage) => setPage(newPage)}
                    onRowsPerPageChange={(newSize) => {
                        setRowsPerPage(newSize);
                        setPage(0);
                    }}
                    selected={selectedDiscountIds}
                    onSelectionChange={(selectedIds) => {
                        setSelectedDiscountIds(selectedIds);
                    }}
                />
            </CustomCard>

        </>
    )
}

export default Discounts